import { typographyVariantConfig } from 'shared/config/typographyVariant.config';
import { TypographyConfig } from 'shared/types/typography';

export const HeadingConfig: TypographyConfig = {
  baseStyle: {
    fontWeight: 'semibold',
  },
  variants: typographyVariantConfig,
  sizes: {
    xs: {
      fontSize: '14px',
      lineHeight: '120%',
    },
    sm: {
      fontSize: '16px',
      lineHeight: '120%',
    },
    md: {
      fontSize: '20px',
      lineHeight: '120%',
    },
    lg: {
      fontSize: ['24px', '30px'],
      lineHeight: ['133%', '120%'],
    },
    xl: {
      fontSize: ['30px', '36px'],
      lineHeight: ['133%', '120%'],
    },
    '2xl': {
      fontSize: ['36px', '48px'],
      lineHeight: ['120%', '100%'],
    },
    '3xl': {
      fontSize: ['48px', '60px'],
      lineHeight: '100%',
    },
    '4xl': {
      fontSize: ['60px', '72px'],
      lineHeight: '100%',
    },
  },
};
